/*
 * @Author: wjc
 * @Date: 2023-11-21 11:31:34
 * @LastEditors: wjc
 * @LastEditTime: 2023-12-11 09:47:25
 * @Description:
 */
import type { IInfo } from '~/models/activity'
import { useOptionStore } from '~/stores/modules/option'

export function useMenuList(m?: string) {
  const route = useRoute()
  const optionStore = useOptionStore()
  const menus = computed(() => optionStore.menus)
  const menuList = ref<IInfo[]>([])
  const currentMenu = ref<IInfo>({})
  const parentMenu = ref<IInfo>({})
  const id = m || route.params.id

  watch(
    () => menus.value,
    (n) => {
      if (n) {
        n.forEach((item) => {
          if (item.children) {
            const menu = item.children.find((c) => c.id === id)
            if (menu) {
              menuList.value = item.children
              currentMenu.value = menu
              parentMenu.value = item
            }
          }
        })
      }
    },
    { deep: true, immediate: true }
  )

  return {
    menuList,
    currentMenu,
    parentMenu,
  }
}
